import { blueGrey, green } from "@material-ui/core/colors";
import { Document, Font, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
// import { Document, Font, Image, Page, StyleSheet, Text, View } from 'react-pdf/dist/esm/entry.webpack';
import React, { FC, useEffect, useMemo, useState } from "react";

Font.register({ family: 'Roboto', fonts: [
	{ src: '/eval/fonts/Roboto-Regular.ttf'},
  { src: '/eval/fonts/Roboto-Black.ttf', fontWeight: 'black' },
	{ src: '/eval/fonts/Roboto-Bold.ttf', fontWeight: 'bold' },
	{ src: '/eval/fonts/Roboto-Light.ttf', fontWeight: 'light' },
  { src: '/eval/fonts/Roboto-Thin.ttf', fontWeight: 'thin' },
 ]});

const styles = StyleSheet.create({

   page: {
      padding: '48px',
      fontFamily: 'Roboto',
   },
	logo: { 
		margin: '10px',
		maxWidth: '100px',
	},
  headerOuter: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    borderBottom: '1px solid #eee',
    marginBottom: '16px'
  },
  headerRight: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  headerLeft: {
    width: '100px'
  },
	 
	h1: {
		flex: 1,
		fontSize: 28,
    fontFamily: 'Roboto',
		fontWeight: 'bold',
		marginTop: 12
	},
   h2: {
    flex: 1,
		fontSize: 20,
    fontFamily: 'Roboto',
		fontWeight: 'bold',
		margin: 5,
		marginTop: 12,
   },
   h3: {
    flex: 1,
		fontSize: 14,
    fontFamily: 'Roboto',
		fontWeight: 'bold',
		margin: 5,
		marginTop: 8,
   },
   subtitle: {
     flex: 1,
      fontSize: 16,
		  fontWeight: 'thin',
   },
   header: {
		fontSize: 8,
		color: 'grey',
		textAlign: 'center',
		margin: 2,
		marginBottom: 10,
   },
	label: {
		flex: 1,
		fontSize: 10,
		fontFamily: 'Roboto',
		fontWeight: 'bold',
		margin: 5,
	},
  subLabel: {
		flex: 1,
		fontSize: 10,
		fontFamily: 'Roboto',
		margin: 5,
	},
  subValue: {
		flex: 1,
    flexGrow: 0,
		fontSize: 10,
    paddingTop: 2,
    paddingBottom: 2,
    fontFamily: 'Roboto',
		fontWeight: 'light',
    textAlign: 'left',
  },
  questionAndAnswerRightLabel: {
    flex: 1,
    flexGrow: 1,
    fontSize: 10,
    paddingTop: 2,
    paddingBottom: 2,
		paddingRight: 10,
    textAlign: 'right',
    fontFamily: 'Roboto',
  },
  questionAndAnswerRightValue: {
		flex: 1,
		fontSize: 10,
    flexGrow: 0,
    paddingTop: 2,
    paddingBottom: 2,
    fontFamily: 'Roboto',
		fontWeight: 'light',
    justifyContent: 'flex-end',
    textAlign: 'right',
  },
  labelRight: {
    flex: 1,
    fontSize: 10,
    justifyContent: 'flex-end',
    margin: 5,
    textAlign: 'right',
    alignItems: 'flex-end',
    fontFamily: 'Roboto',
  },
	minorLabel: {
		fontSize: 12,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    backgroundColor: green[500],
    color: 'white',
    padding: 4,
    margin: 5,
	},
	value: {
		flex: 1,
		fontSize: 10,
		margin: 3,
    justifyContent: 'flex-end',
    fontFamily: 'Roboto',
		fontWeight: 'light',
    textAlign: 'right',
	},
	question: {
		flex: 1,
		fontSize: 10,
    flexGrow: 3,
		margin: 3,
		textAlign: 'left',
 	},
	view: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignContent: 'center',
    alignItems: 'center',
	},
  multipleQuestion: {
    borderTop: '0.5px solid #ddd',
    marginTop: '8px'
  },
  multipleQuestionLabel: {
    fontWeight: 'bold',
  },
  multipleQuestionQuestionAndAnswers: {

  },
  multipleQuestionQuestion: {
		fontSize: 10,
		marginLeft: 5,
		textAlign: 'left',
    paddingBottom: 2
  },
  multipleAnswer: {
    borderTop: '0.5px solid #ddd',
    marginTop: '8px'
  },
  multipleAnswerLabel: {
    fontWeight: 'bold',
    fontFamily: 'Roboto',
  },
  multipleAnswerAnswers: {

  },
  questionRight: {
    flex: 1,
		fontSize: 10,
    flexGrow: 5,
		margin: 5,
		textAlign: 'left',
    borderTop: '0.5px solid #ddd'
  },
  questionAndAnswerRow: {
    borderTop: '0.5px solid #ddd',
    marginTop: '8px'
  },
  questionAndAnswerRowLabel: {
    fontSize: 10,
		fontFamily: 'Roboto',
		fontWeight: 'bold',
		margin: 5
  },
  questionAndAnswerRowQuestion: {
    fontSize: 10,
    marginLeft: 5,
		textAlign: 'left',
  },
  questionAndAnswerRowValue: {
    flex: 1,
    flexGrow: 0,
		fontSize: 10,
    fontFamily: 'Roboto',
		fontWeight: 'light',
    textAlign: 'right',
    justifyContent: 'flex-end',
    margin: 4,
  },
  blank: {
    opacity: 0,
    height: 0
  },
  notesRow: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 5
  },
  notesRowLabel: {
    flex: 1,
    flexGrow: 1,
    textAlign: 'left',
    fontSize: 10,
		fontFamily: 'Roboto',
    // marginRight: 5
		// margin: 5,
  },
  notesRowNotes: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flex: 1,
    flexGrow: 9,
    fontWeight: 'bold',
    fontSize: 10,
		// margin: 5,
    fontFamily: 'Roboto',
  },
  notesRowAutoNotes: {
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: 10,
    fontFamily: 'Roboto',
  },
  notesRowUserNotes: {
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: 10,
    fontFamily: 'Roboto',
  },
  questionAndAnswerLeft: {
    display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignContent: 'center',
		alignItems: 'center',
    // paddingRight: 20,
    borderTop: '0.5px solid #ddd'
  },
  questionAndAnswerLeftLabel: {
    flex: 1,
    fontSize: 10,
    fontFamily: 'Roboto',
    margin: 5,
  },
  questionAndAnswerLeftValue: {
    flex: 1,
    // flexGrow: 0,
    fontSize: 10,
    paddingTop: 2,
    paddingBottom: 2,
    fontFamily: 'Roboto',
    fontWeight: 'light',
    textAlign: 'right',
  },
  fullWidthViewRight: {
    display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignContent: 'center',
		alignItems: 'center',
    paddingRight: 20,
    borderTop: '0.5px solid #ddd'
  },
	fullWidthView: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignContent: 'center',
		alignItems: 'center',
    borderTop: '0.5px solid #ddd'
	},
	dairyBar: {
		fontSize: 12,
      fontFamily: 'Roboto',
		fontWeight: 'bold',
      backgroundColor: green[500],
      color: 'white',
      padding: 4,
      // margin: 5,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between'
	},
	rowHeader: {
      width: '50%',
      fontFamily: 'Roboto',
      fontWeight: 'bold',
	},
	rowValues: {
      width: '50%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around'
	},
	animalScoringBodyRow: {
		padding: 5,
		fontSize: 10,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between'
	},
	animalScoringBodyRowBorderBottom: {
		padding: 5,
		fontSize: 10,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		borderBottom: '1px solid #eee'
	},
	animalScoringBodyCell: {
    flex: 1,
    flexGrow: 1,
    fontSize: 8,
    textAlign: 'center'
	},
	animalScoringHeaderCell: {
	
	},
	animalScoringHeaderRow: {

	},
	actionPlanBar: {
		backgroundColor: blueGrey[500],
		color: 'white',
		padding: 5,
		margin: 5,
		fontSize: 12
	},
	outer: {
	//  display: 'flex',
		width: '100%'
	},
   section: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
   },
   left: {
      flex: 1,
      width: '50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start'
   },
   leftQuestion: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      fontFamily: 'Roboto',
      fontWeight: 'bold',
   },
   right: {
      flex: 1,
      width: '50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start'
   },
 });

 const QuestionAndAnswerRight = (props: { label: any; question?: any; value?: any; fullWidth?: boolean; right?: boolean}) => {
  const { label, question, value } = props;
  return (
   label && (
     <View style={styles.fullWidthViewRight} wrap={false}>
       <Text style={styles.questionAndAnswerRightLabel}>{ label }</Text>
       {question && (
           <Text style={styles.questionRight}>{ question ?? null }</Text>
       )}
        <Text style={styles.subValue}>{ value ?? 'N/A' }</Text>
     </View>
   )
 )
};

const QuestionAndAnswerLeft = (props: { label: any; question?: any; value?: any; fullWidth?: boolean; left?: boolean}) => {
  const { label, question, value } = props;
  return (
   label && (
     <View style={styles.questionAndAnswerLeft} wrap={false}>
       <Text style={styles.questionAndAnswerLeftLabel}>{ label }</Text>
        <Text style={styles.questionAndAnswerLeftValue}>{ value ?? 'N/A' }</Text>
     </View>
   )
 )
};

/**
 * Any empty expressions or childless elements will crash react-pdf. Use this instead
 */
const BlankRow = () => {
  return <Text style={styles.blank}>.</Text>
}

const AnimalScoringRow = (props: { label: string, values: (number | null)[], total: number }) => {
  const { label, values, total } = props;

  const [ percentages, setPercentages ] = useState<number[]>([]);

  useEffect(() => {
    // if (percentages.some(p => p)) {
    //   return;
    // }
    if (total && values) {
      setPercentages((values as number[]).map(value => {
        return Math.round((value / total) * 10000) / 100;
      }))
    }
  }, [ ])

  const cells = useMemo(() => {
    return values
      .map((value, i) => {
        if (value !== null) {
          return <Text key={i} style={styles.animalScoringBodyCell}>{ `${value}` + `${value !== 0 ? ' (' + percentages[i] + '%)' : ''}` }</Text>
        } else {
          return <Text key={i} style={styles.animalScoringBodyCell}></Text>
        }
      })
  }, [ values, percentages ])

  return (
    <View style={styles.animalScoringBodyRowBorderBottom}>
      <Text style={styles.rowHeader}>{ label }</Text>
      <View style={styles.rowValues}>
        { cells }
      </View>
    </View>
  )
}

const NotesRow = (props: { userNotes?: string, autoNotes?: string }) => {
  const { userNotes, autoNotes } = props;
  
  return (
    <View style={styles.notesRow}>
      <Text style={styles.notesRowLabel}>Notes:</Text>
      <View style={styles.notesRowNotes}>
        { autoNotes && (
          <Text style={styles.notesRowAutoNotes}>{ autoNotes ?? 'N/A' }</Text>
        )}
        { ( autoNotes && userNotes ) && <Text>{'-'}</Text> }
        { userNotes && (
          <Text style={styles.notesRowUserNotes}>{ userNotes ?? 'N/A' }</Text>
        )}
      </View>
    </View>
  )
}

const QuestionAndAnswerRow = (props: { label: any; question?: any; value?: any; fullWidth?: boolean; right?: boolean}) => {
  const { label, question, value } = props;

  return (
   label && (
     <View style={styles.questionAndAnswerRow} wrap={false}>
       <Text style={styles.questionAndAnswerRowLabel}>{ label }</Text>
       {question && (
           <Text style={styles.questionAndAnswerRowQuestion}>{ question ?? null }</Text>
       )}
        <Text style={styles.questionAndAnswerRowValue}>{ value ?? 'N/A' }</Text>
     </View>
   )
 )
}

 const QuestionAndAnswer = (props: { label: any; question?: any; value?: any; fullWidth?: boolean; right?: boolean}) => {
   const { label, question, value } = props;

   return (
    label && (
      <View style={props.fullWidth ? styles.fullWidthView : styles.view}>
        <Text style={props.right ? styles.labelRight : styles.label}>{ label }</Text>
        {question && (
            <Text style={styles.question}>{ question ?? null }</Text>
        )}
         <Text style={styles.value}>{ value ?? 'N/A' }</Text>
      </View>
    )
  )
}

const Question = (props: { label: any; question?: any; fullWidth?: boolean }) => {
   const { label, question } = props;
   return (
    label && (
			<View>
				<View style={styles.leftQuestion}>
					<Text style={styles.label}>{ label }</Text>
        </View>
        <View style={styles.fullWidthView}>
					{question && (
							<Text style={styles.question}>{ question ?? null }</Text>
					)}
				</View>
			</View>
    )
  )
}

const MultipleAnswer = (props: { label: any; value?: any; fullWidth?: boolean; right?: boolean, answers?: any[]}) => {
  const { label, answers } = props;

  return (
    <View style={styles.multipleAnswer} wrap={false}>
      <View style={styles.multipleAnswerLabel}>
        <Text style={styles.label}>{ label }</Text>
      </View>
      <View style={styles.multipleAnswerAnswers}>
        {
          answers?.map((a, i) => {
            return <QuestionAndAnswerRight key={i} right={true} label={a.label} value={a.value} />
          })
        }
      </View>
    </View>
  )
};

const MultipleQuestion = (props: { label: any; question?: any; value?: any; fullWidth?: boolean; right?: boolean, answers?: any[]}) => {
  const { label, question, value, answers } = props;

  return (
    <View style={styles.multipleQuestion} wrap={false}>
      <View style={styles.multipleQuestionLabel}>
        <Text style={styles.label}>{ label }</Text>
      </View>
      <View style={styles.multipleQuestionQuestionAndAnswers}>
          <View>
            {question && (
              <Text style={styles.multipleQuestionQuestion}>{ question ?? null }</Text>
            )}
          </View>
        {
          answers?.map((a, i) => {
            return <QuestionAndAnswerRight key={i} right={true} label={a.label} value={a.value} />
          })
        }
      </View>
    </View>
  )
};

// const ActionPlan = (props: { title?: any; issue?: any; due?: any; resolution?: any; }) => {
//    const { title, issue, due, resolution } = props;
   
//    if (!title) {
//       return null;
//    }

//    return (
//     title && (
// 			<View>
// 				<View style={styles.leftQuestion}>
// 					<Text style={styles.label}>{ issue ?? null }</Text>
//                <Text style={styles.label}>{ due ?? null }</Text>
//                <Text style={styles.label}>{ resolution ?? null }</Text>
//             </View>
// 			</View>
//     )
//   )
// }

export const EvaluationDocument: FC<any> = props => {

  const { data, schema } = props;

  const [ deskEval, setDeskEval ] = useState(false)

  //  useEffect(() => {
  //     setDeskEval(data.deskEval)
  //     return () => {
  //        cleanup
  //     }
  //  }, [input])
	
	const infoMessage = 'This report is for informational purposes only. Please contact your evaluator or dairyfarm@nmpf.org to receive the full report after it is completed.';

   // console.log(deskEval, data, schema);

  const observations = 'data.herd.observations.summary.';

   return (
      data ? (
        deskEval ?
          <Document 
            title="National Dairy FARM Evaluation"
            author="NMPF"
            subject="NMPF Evaluation"
          >
            <Page size="A4">
              <View fixed >
                <Text style={styles.header}>{ infoMessage }</Text>
              </View>
            
              <View style={styles.outer}>
                <Image src={'/eval/images/logo-512.png'} style={styles.logo}/>
                <Text style={styles.h1}>Animal Care Desk Evaluation</Text>
                <Text style={styles.subtitle}>National Dairy FARM Program</Text>

                <View style={styles.section}>
                  <View style={styles.left}>
                    <QuestionAndAnswer label={'Farm Name: '} value={data.farm.name} />
                    <QuestionAndAnswer label={'Facility Name: '} value={data.facility.name} />

                    <QuestionAndAnswer label={'Evaluation Date: '} value={data.info.evalDate} />
                    <QuestionAndAnswer label={'Evaluator Name: '} value={data.evaluator.name} />

                    <QuestionAndAnswer label={'Participant: '} value={data.coop.name} />
                  </View>
                  <View style={styles.right}>
                    <View>
                    </View>
                  </View>
                </View>
              </View>
            </Page>
          </Document>
        : <Document 
            title="National Dairy FARM Evaluation"
            author="NMPF"
            subject="NMPF Evaluation"
          >
          <Page size="A4" style={styles.page}>
            <View fixed >
               <Text style={styles.header}>{ infoMessage }</Text>
            </View>
            <View style={styles.outer}>
              <View style={styles.headerOuter}>
                <View style={styles.headerLeft}>
                  <Image src='/eval/images/logo-512.png' style={styles.logo}/>
                </View>
                <View style={styles.headerRight}>
                  <Text style={styles.h1}>Animal Care Evaluation</Text>
                  <Text style={styles.subtitle}>National Dairy FARM Program</Text>
                </View>
              </View>
              <Text style={styles.minorLabel}>Facility Information</Text>
              <View style={styles.section}>
                <View style={styles.left}>
                  <QuestionAndAnswer label={'Farm Name: '} value={data.farm.name} />
                  <QuestionAndAnswer label={'Facility Name: '} value={data.facility.name} />

                  <QuestionAndAnswer label={'Physical Address: '} value={data.facility.address} />
                  <QuestionAndAnswer label={'State: '} value={data.facility.state} />
                  <QuestionAndAnswer label={'City: '} value={data.facility.city} />
                  <QuestionAndAnswer label={'Zip: '} value={data.facility.zip} />

                  <QuestionAndAnswer label={'Evaluation Date: '} value={data.evalDate} />

                  <QuestionAndAnswer label={'Participant: '} value={data.coop.name} />

                  <QuestionAndAnswer label={'Facility Manager: '} value={data.manager.name} />
                  <QuestionAndAnswer label={'Manager Email: '} value={data.manager.email} />
                  <QuestionAndAnswer label={'Manager Phone: '} value={data.manager.phone} />
                </View>
                <View style={styles.right}>
                  <QuestionAndAnswer label={'Premise ID: '} value={data.facility.premises_id} />
                  <QuestionAndAnswer label={'Total # of Employees: '} value={data.employees.numFamily + data.employees.numNonFamily} />
                  <QuestionAndAnswer label={'# Immediate Family (18+) '} value={data.employees.numFamily} />
                  <QuestionAndAnswer label={'# of Employees (18+): '} value={data.employees.numNonFamily} />
                </View>
              </View>
              <View>
              <Text style={styles.minorLabel}>Evaluator Information</Text>
                <View>
                  <QuestionAndAnswer fullWidth={true} label={'Primary Evaluator: '} value={data.evaluator.name} />
                  <QuestionAndAnswer fullWidth={true} label={'Phone: '} value={data.evaluator.phone} />
                  <QuestionAndAnswer fullWidth={true} label={'Email: '} value={data.evaluator.email} />
                  <QuestionAndAnswer fullWidth={true} label={'Participant: '} value={data.evaluator.company} />
                </View>
              </View>
            </View>
          </Page>
          <Page size="A4" style={styles.page}>
            <View>
              <Text style={styles.h2}>Evaluation Summary Sheet</Text>
              <Text style={styles.h3}>Animal Observation Summary</Text>

              <View>
                <View style={{ display: 'flex', flexDirection: 'column' }}>
                  <View style={styles.dairyBar}>
                    <Text style={styles.rowHeader}>Pre-weaned Calves</Text>
                    <View style={styles.rowValues}>
                      <Text style={styles.animalScoringHeaderCell}>1</Text>
                      <Text style={styles.animalScoringHeaderCell}>2</Text>
                      <Text style={styles.animalScoringHeaderCell}>3</Text>
                      <Text style={styles.animalScoringHeaderCell}>4</Text>
                      <Text style={styles.animalScoringHeaderCell}>5</Text>
                    </View>
                  </View>

                  <AnimalScoringRow
                    label={'Body Condition Score'}
                    values={[
                      (data.herd.observations.summary.calves.bodyCond.b1 ?? 0),
                      (data.herd.observations.summary.calves.bodyCond.b2 ?? 0),
                      (data.herd.observations.summary.calves.bodyCond.b3 ?? 0),
                      (data.herd.observations.summary.calves.bodyCond.b4 ?? 0),
                      (data.herd.observations.summary.calves.bodyCond.b5 ?? 0)
                    ]}
                    total={
                      (data.herd.observations.summary.calves.bodyCond.b1 ?? 0) +
                      (data.herd.observations.summary.calves.bodyCond.b2 ?? 0) +
                      (data.herd.observations.summary.calves.bodyCond.b3 ?? 0) +
                      (data.herd.observations.summary.calves.bodyCond.b4 ?? 0) +
                      (data.herd.observations.summary.calves.bodyCond.b5 ?? 0)
                    }
                    />

                  <AnimalScoringRow
                    label={'Hygiene'}
                    values={[
                      (data.herd.observations.summary.calves.hygiene.h1 ?? 0),
                      (data.herd.observations.summary.calves.hygiene.h2 ?? 0),
                      (data.herd.observations.summary.calves.hygiene.h3 ?? 0),
                      null,
                      null
                    ]}
                    total={
                      (data.herd.observations.summary.calves.hygiene.h1 ?? 0) +
                      (data.herd.observations.summary.calves.hygiene.h2 ?? 0) +
                      (data.herd.observations.summary.calves.hygiene.h3 ?? 0) 
                    }
                  />

                <View style={{ display: 'flex', flexDirection: 'column' }}>
                  <View style={styles.dairyBar}>
                    <Text style={styles.rowHeader}>Weaned Heifers</Text>
                      <View style={styles.rowValues}>
                      <Text style={styles.animalScoringHeaderCell}>1</Text>
                      <Text style={styles.animalScoringHeaderCell}>2</Text>
                      <Text style={styles.animalScoringHeaderCell}>3</Text>
                      <Text style={styles.animalScoringHeaderCell}>4</Text>
                      <Text style={styles.animalScoringHeaderCell}>5</Text>
                    </View>
                  </View>
                </View>

                <AnimalScoringRow
                  label={'Body Condition Score'}
                  values={[
                    (data.herd.observations.summary.heifers.bodyCond.b1 ?? 0),
                    (data.herd.observations.summary.heifers.bodyCond.b2 ?? 0),
                    (data.herd.observations.summary.heifers.bodyCond.b3 ?? 0),
                    (data.herd.observations.summary.heifers.bodyCond.b4 ?? 0),
                    (data.herd.observations.summary.heifers.bodyCond.b5 ?? 0)
                  ]}
                  total={
                    (data.herd.observations.summary.heifers.bodyCond.b1 ?? 0) +
                    (data.herd.observations.summary.heifers.bodyCond.b2 ?? 0) +
                    (data.herd.observations.summary.heifers.bodyCond.b3 ?? 0) +
                    (data.herd.observations.summary.heifers.bodyCond.b4 ?? 0) +
                    (data.herd.observations.summary.heifers.bodyCond.b5 ?? 0)
                  }
                />
              
                <AnimalScoringRow
                  label={'Hygiene'}
                  values={[
                    (data.herd.observations.summary.heifers.hygiene.h1 ?? 0),
                    (data.herd.observations.summary.heifers.hygiene.h2 ?? 0),
                    (data.herd.observations.summary.heifers.hygiene.h3 ?? 0),
                    null,
                    null
                  ]}
                  total={
                    (data.herd.observations.summary.heifers.hygiene.h1 ?? 0) +
                    (data.herd.observations.summary.heifers.hygiene.h2 ?? 0) +
                    (data.herd.observations.summary.heifers.hygiene.h3 ?? 0) 
                  }
                />
              </View>

                <View style={{ display: 'flex', flexDirection: 'column' }}>
                  <View style={styles.dairyBar}>
                    <Text style={styles.rowHeader}>Dry (60 days-fresh) and Pre-fresh Heifers/Cows</Text>
                    <View style={styles.rowValues}>
                      <Text style={styles.animalScoringHeaderCell}>1</Text>
                      <Text style={styles.animalScoringHeaderCell}>2</Text>
                      <Text style={styles.animalScoringHeaderCell}>3</Text>
                      <Text style={styles.animalScoringHeaderCell}>4</Text>
                      <Text style={styles.animalScoringHeaderCell}>5</Text>
                    </View>
                  </View>

                  <AnimalScoringRow
                    label={'Hygiene'}
                    values={[
                      (data.herd.observations.summary.preFresh.hygiene.h1 ?? 0),
                      (data.herd.observations.summary.preFresh.hygiene.h2 ?? 0),
                      (data.herd.observations.summary.preFresh.hygiene.h3 ?? 0),
                      null,
                      null
                    ]}
                    total={
                      (data.herd.observations.summary.preFresh.hygiene.h1 ?? 0) +
                      (data.herd.observations.summary.preFresh.hygiene.h2 ?? 0) +
                      (data.herd.observations.summary.preFresh.hygiene.h3 ?? 0) 
                    }
                  />
                </View>

                <View style={{ display: 'flex', flexDirection: 'column' }}>
                  <View style={styles.dairyBar}>
                    <Text style={styles.rowHeader}>Lactating Cows</Text>
                    <View style={styles.rowValues}>
                      <Text style={styles.animalScoringHeaderCell}>1</Text>
                      <Text style={styles.animalScoringHeaderCell}>2</Text>
                      <Text style={styles.animalScoringHeaderCell}>3</Text>
                      <Text style={styles.animalScoringHeaderCell}>4</Text>
                      <Text style={styles.animalScoringHeaderCell}>5</Text>
                    </View>
                  </View>

                  <AnimalScoringRow
                    label={'Body Condition Score'}
                    values={[
                      (data.herd.observations.summary.milking.bodyCond.b1 ?? 0),
                      (data.herd.observations.summary.milking.bodyCond.b2 ?? 0),
                      (data.herd.observations.summary.milking.bodyCond.b3 ?? 0),
                      (data.herd.observations.summary.milking.bodyCond.b4 ?? 0),
                      (data.herd.observations.summary.milking.bodyCond.b5 ?? 0)
                    ]}
                    total={
                      (data.herd.observations.summary.milking.bodyCond.b1 ?? 0) +
                      (data.herd.observations.summary.milking.bodyCond.b2 ?? 0) +
                      (data.herd.observations.summary.milking.bodyCond.b3 ?? 0) +
                      (data.herd.observations.summary.milking.bodyCond.b4 ?? 0) +
                      (data.herd.observations.summary.milking.bodyCond.b5 ?? 0)
                    }
                  />

                  <AnimalScoringRow
                    label={'Hygiene'}
                    values={[
                      (data.herd.observations.summary.milking.hygiene.h1 ?? 0),
                      (data.herd.observations.summary.milking.hygiene.h2 ?? 0),
                      (data.herd.observations.summary.milking.hygiene.h3 ?? 0),
                      null,
                      null
                    ]}
                    total={
                      (data.herd.observations.summary.milking.hygiene.h1 ?? 0) +
                      (data.herd.observations.summary.milking.hygiene.h2 ?? 0) +
                      (data.herd.observations.summary.milking.hygiene.h3 ?? 0) 
                    }
                  />

                  <AnimalScoringRow
                    label={'Lameness'}
                    values={[
                      (data.herd.observations.summary.milking.lameness.h1 ?? 0),
                      (data.herd.observations.summary.milking.lameness.h2 ?? 0),
                      (data.herd.observations.summary.milking.lameness.h3 ?? 0),
                      null,
                      null
                    ]}
                    total={
                      (data.herd.observations.summary.milking.lameness.h1 ?? 0) +
                      (data.herd.observations.summary.milking.lameness.h2 ?? 0) +
                      (data.herd.observations.summary.milking.lameness.h3 ?? 0) 
                    }
                  />

                  <AnimalScoringRow
                    label={'Hocks'}
                    values={[
                      (data.herd.observations.summary.milking.hocks.h1 ?? 0),
                      (data.herd.observations.summary.milking.hocks.h2 ?? 0),
                      (data.herd.observations.summary.milking.hocks.h3 ?? 0),
                      null,
                      null
                    ]}
                    total={
                      (data.herd.observations.summary.milking.hocks.h1 ?? 0) +
                      (data.herd.observations.summary.milking.hocks.h2 ?? 0) +
                      (data.herd.observations.summary.milking.hocks.h3 ?? 0) 
                    }
                  />

                  <AnimalScoringRow
                    label={'Knees'}
                    values={[
                      (data.herd.observations.summary.milking.knees.h1 ?? 0),
                      (data.herd.observations.summary.milking.knees.h2 ?? 0),
                      (data.herd.observations.summary.milking.knees.h3 ?? 0),
                      null,
                      null
                    ]}
                    total={
                      (data.herd.observations.summary.milking.knees.h1 ?? 0) +
                      (data.herd.observations.summary.milking.knees.h2 ?? 0) +
                      (data.herd.observations.summary.milking.knees.h3 ?? 0) 
                    }
                  />

                  <View style={{ display: 'flex', flexDirection: 'column' }}>
                     <View style={styles.dairyBar}>
                        <Text style={styles.rowHeader}></Text>
                        <View style={styles.rowValues}>
                           <Text style={styles.animalScoringHeaderCell}>Yes</Text>
                           <Text style={styles.animalScoringHeaderCell}>No</Text>
                        </View>
                     </View>
                  </View>

                  <AnimalScoringRow
                    label={'Broken Tails'}
                    values={[
                      (data.herd.observations.summary.milking.tail.yes ?? 0),
                      (data.herd.observations.summary.milking.tail.no ?? 0),
                    ]}
                    total={
                      (data.herd.observations.summary.milking.tail.yes ?? 0) +
                      (data.herd.observations.summary.milking.tail.no ?? 0) 
                    }
                  />
                </View>
              </View>
            </View>

          {/* <View>
            <Text style={styles.subtitle}>Action Plans</Text>
            <Text style={styles.actionPlanBar}>Action Plan</Text>
          </View>

          <View>
            <ActionPlan 
               title={data.questions.q1.nonFamily.mcap.title} 
               issue={data.questions.q1.nonFamily.mcap.issue} 
               due={data.questions.q1.nonFamily.mcap.deadline}
               resolution={data.questions.q1.nonFamily.mcap.resolution}
            />
          </View> */}
          
        </Page>
        <Page size="A4" style={styles.page}>
          <View>
					<Text style={styles.h2}>Facility Details</Text>
               <View style={styles.section}>
                  <View style={styles.left}>
                     <Text style={styles.minorLabel}>On-Site Animals</Text>
                     
                     <QuestionAndAnswer label={'Total Animals: '} value={data.herd.profile.numTotalAnimalsOnsite} />
                     <QuestionAndAnswer label={'Newborn Calves: '} value={data.herd.profile.numNewbornOnsite} />
                     <QuestionAndAnswer label={'Preweaned Calves: '} value={data.herd.profile.numPreweanedOnsite} />
                     <QuestionAndAnswer label={'Weaned Heifers: '} value={data.herd.profile.numHeifersOnsite} />
                     <QuestionAndAnswer label={'Pre-fresh Heifers: '} value={data.herd.profile.numPrefreshOnsite} />
                     <QuestionAndAnswer label={'Dry Cows: '} value={data.herd.profile.numDryOnsite} />
                     <QuestionAndAnswer label={'Lactating Cows: '} value={data.herd.profile.numLactatingOnsite} />
                     <QuestionAndAnswer label={'Bulls: '} value={data.herd.profile.numBullsOnsite} />
                     <QuestionAndAnswer label={'Total Animals On-site and Off-site: '} value={data.herd.profile.numTotalAnimalsOnsite} />

                  </View>
                  <View style={styles.right}>
                     <Text style={styles.minorLabel}>Off-Site Animals</Text>

                     <QuestionAndAnswer label={'Total Animals: '} value={data.herd.profile.numTotalAnimalsOffsite} />
                     <QuestionAndAnswer label={'Newborn Calves: '} value={data.herd.profile.numNewbornOffsite} />
                     <QuestionAndAnswer label={'Preweaned Calves: '} value={data.herd.profile.numPreweanedOffsite} />
                     <QuestionAndAnswer label={'Weaned Heifers: '} value={data.herd.profile.numHeifersOffsite} />
                     <QuestionAndAnswer label={'Pre-fresh Heifers: '} value={data.herd.profile.numPrefreshOffsite} />
                     <QuestionAndAnswer label={'Dry Cows: '} value={data.herd.profile.numDryOffsite} />
                     <QuestionAndAnswer label={'Lactating Cows: '} value={data.herd.profile.numLactatingOffsite} />
                     <QuestionAndAnswer label={'Bulls: '} value={data.herd.profile.numBullsOffsite} />

                  </View>
               </View>

               <View style={styles.section}>
                  <View style={styles.left}>
                     <Text style={styles.minorLabel}>Housing Facilities</Text>
                     
                     <QuestionAndAnswer label={'Pre-weaned Calves: '} value={data.housing.calf} />
                     <QuestionAndAnswer label={'Calves Tethered?: '} value={data.housing.calfTethered} />
                     <QuestionAndAnswer label={'Calf Weaning Age (weeks): '} value={data.housing.calfWeaningAge} />
                     <QuestionAndAnswer label={'Heifer: '} value={data.housing.heifer} />
                     <QuestionAndAnswer label={'Dry: '} value={data.housing.dry} />
                     <QuestionAndAnswer label={'Lactating: '} value={data.housing.milk} />
                     <QuestionAndAnswer label={'Hospital Pen: '} value={data.housing.sick} />

                  </View>
                  <View style={styles.right}>
                     <Text style={styles.minorLabel}>Cull & Somatic Cell Count</Text>

                     <QuestionAndAnswer label={'Annual Cull Rate %: '} value={data.facility.cullRate} />
                     <QuestionAndAnswer label={'Somatic Cell Count: '} value={data.herd.somaticCellCount} />

                  </View>
               </View>

               <View style={styles.section}>
                  <View style={styles.left}>
                     <Text style={styles.minorLabel}>Mortality Rates</Text>
                     
                     <QuestionAndAnswer label={'Stillborn %: '} value={data.herd.mortality.stillborn} />
                     <QuestionAndAnswer label={'Pre-weaned Calves %: '} value={data.herd.mortality.preweaned} />
                     <QuestionAndAnswer label={'Heifers %: '} value={data.herd.mortality.heifer} />
                     <QuestionAndAnswer label={'Cows %: '} value={data.herd.mortality.cows} />

                  </View>
                  <View style={styles.right}>
                     <Text style={styles.minorLabel}>Milking Facilities</Text>

                     <QuestionAndAnswer label={'Primary Type: '} value={data.milking.facility1.setup} />
                     <QuestionAndAnswer label={'Secondary Type: '} value={data.milking.facility2.setup} />
                     <QuestionAndAnswer label={'Tertiary Type: '} value={data.milking.facility3.setup} />
                     <QuestionAndAnswer label={'Hospital Pen: '} value={data.milking.hospital.setup} />
                     
                  </View>
               </View>

               <Text style={styles.minorLabel}>Informational</Text>

                     <QuestionAndAnswer fullWidth={true} label={'Polled Dairy Bull Purchased Semen %: '} value={data.informational.semenPurchasedPercent} />
                     <QuestionAndAnswer fullWidth={true} label={'Aware of FARM Workforce Development? '} value={data.informational.awareFarmWorkforceDev} />
                     <QuestionAndAnswer fullWidth={true} label={'Aware of FARM ES? '} value={data.informational.awareFarmES} />
                     <QuestionAndAnswer fullWidth={true} label={'Completed a FARM ES assessment? '} value={data.informational.completedFarmES} />
                     <QuestionAndAnswer fullWidth={true} label={'Has NMPF Drug & Residue Prevention Manual? '} value={data.informational.hasDrugResidualManual} />
                     <QuestionAndAnswer fullWidth={true} label={'Participates in other auditing programs? '} value={data.informational.hasOtherAuditPrograms} />
                     <QuestionAndAnswer fullWidth={true} label={'Other auditing programs: '} value={data.informational.otherAuditPrograms} />
                     <QuestionAndAnswer fullWidth={true} label={'Utilizes Activity Monitoring Systems? '} value={data.informational.hasAnimalMonitoring} />
            </View>
        </Page>

        <Page size="A4" style={styles.page}>
            
            <View>
              <Text style={styles.h2}>Interview, Document Review & Observation</Text>

              <MultipleQuestion
                label={'1. Continuing Education'}
                question={'Do all family and non-family employees with animal care responsibilities have an annually signed cow care agreement that has been signed within the last year?'}
                answers={[{
                  label: 'Family',
                  value: data.questions.q1.family.answer
                },
                {
                  label: 'Non-Family',
                  value: data.questions.q1.nonFamily.answer
                }]}
              />
              { ( data.questions.q1.notes || data.employees.familyNonFamilyAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q1.notes} autoNotes={data.employees.familyNonFamilyAutoAnswerNotes} /> : <BlankRow /> }

              <MultipleQuestion
                label={'2. Continuing Education'}
                question={'Do all family and non-family employees with animal care responsibilities have documented annual continuing education in proper stockmanship (animal handling and restraint for all age classes of animals) that has been conducted within the last year?'}
                answers={[{
                  label: 'Family',
                  value: data.questions.q2.family.answer
                },
                {
                  label: 'Non-Family',
                  value: data.questions.q2.nonFamily.answer
                }]}
              />
              { ( data.questions.q2.notes || data.employees.familyNonFamilyAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q2.notes} autoNotes={data.employees.familyNonFamilyAutoAnswerNotes} /> : <BlankRow />}

              <MultipleQuestion
                label={'3. Continuing Education'}
                question={'Do all family and non family employees with pre-weaned calf management responsibilities have documented annual continuing education on the written pre-weaned calf management protocol that has been conducted within the last year?'}
                answers={[{
                  label: 'Family',
                  value: data.questions.q3.family.answer
                },
                {
                  label: 'Non-Family',
                  value: data.questions.q3.nonFamily.answer
                }]}
              />
              { ( data.questions.q3.notes || data.employees.familyNonFamilyAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q3.notes} autoNotes={data.employees.familyNonFamilyAutoAnswerNotes} /> : <BlankRow />}

              <MultipleQuestion
                label={'4. Continuing Education'}
                question={'Do all the family and non-family employees with determination of fitness to transport responsibilities have documented annual continuing education on the written protocol for fitness to transport that has been conducted within the last year?'}
                answers={[{
                  label: 'Family',
                  value: data.questions.q4.family.answer
                },
                {
                  label: 'Non-Family',
                  value: data.questions.q4.nonFamily.answer
                }]}
              />
              { ( data.questions.q4.notes || data.employees.familyNonFamilyAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q4.notes} autoNotes={data.employees.familyNonFamilyAutoAnswerNotes} /> : <BlankRow />}

              <MultipleQuestion
                label={'5. Continuing Education'}
                question={'Do all family and non family employees with non-ambulatory animal responsibilities have documented annual continuing education on the written non-ambulatory animal management protocol that has been conducted within the past year?'}
                answers={[{
                  label: 'Family',
                  value: data.questions.q5.family.answer
                },
                {
                  label: 'Non-Family',
                  value: data.questions.q5.nonFamily.answer
                }]}
              />
              { ( data.questions.q5.notes || data.employees.familyNonFamilyAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q5.notes} autoNotes={data.employees.familyNonFamilyAutoAnswerNotes} /> : <BlankRow />}

              <MultipleQuestion
                label={'6. Continuing Education'}
                question={'Do all family and non family employees with euthanasia responsibilities have documented annual continuing education on the written euthanasia protocols, identification of animals that are to be euthanized and proper euthanasia techniques that has been conducted within the last year?'}
                answers={[{
                  label: 'Family',
                  value: data.questions.q6.family.answer
                },
                {
                  label: 'Non-Family',
                  value: data.questions.q6.nonFamily.answer
                }]}
              />
              { ( data.questions.q6.notes || data.employees.familyNonFamilyAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q6.notes} autoNotes={data.employees.familyNonFamilyAutoAnswerNotes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'7. Antibiotic Stewardship'}
                question={'Have all official samples of sold milk from the facility tested negative for antibiotics in the last three years?'}
                value={data.questions.q7.answer}
              />
              { data.questions.q7.notes ? <NotesRow userNotes={data.questions.q7.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'8. Antibiotic Stewardship'}
                question={'Have all meat tissues from animals processed for meat production tested negative for violative residues in the last three years?'}
                value={data.questions.q8.answer}
              />
              { data.questions.q8.notes ? <NotesRow userNotes={data.questions.q8.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'9. Veterinarian Review'}
                question={'Does the facility have a written Veterinarian Client Patient Relationship (VCPR) form signed and updated by the farm owner/manager and the Veterinarian of Record (VOR) annually, that has been signed within the last year?'}
                value={data.questions.q9.answer}
              />

              <QuestionAndAnswerLeft
                label={'Date of most recent VCPR Signature:'}
                value={data.questions.q9.signDate}
              />

              { data.questions.q9.notes ? <NotesRow userNotes={data.questions.q9.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'10. Veterinarian Review'}
                question={'Is the Written Herd Health Plan reviewed annually by the Veterinarian of Record and the review has been conducted within the past year?'}
                value={data.questions.q10.answer}
              />
              <QuestionAndAnswerLeft
                label={'Date of most recent Veterinarian of Record review:'}
                value={data.questions.q10.reviewDate}
              />

              { data.questions.q10.notes ? <NotesRow userNotes={data.questions.q10.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'11. Veterinarian Review'}
                question={'Does the facility maintain permanent (written or electronic) treatment records, available for review by the Veterinarian of Record, for the treatment of the facility\'s common diseases that includes: 1. Date of treatment, 2. Animal treated identification, 3. Name of the treatment used, 4. Disease/condition being treated, 5. Dosage Administered, 6. Route of Administration, 7. Duration of the treatment, and 8. Specified withdrawal times for milk and meat to ensure food safety?'}
                value={data.questions.q11.answer}
              />
              <QuestionAndAnswerLeft
                label={'How are treatment records recorded?'}
                value={data.questions.q11.recordMethods}
              />
              { data.questions.q11.notes ? <NotesRow userNotes={data.questions.q11.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'12. Facility Observations'}
                question={'Are the names and telephone numbers for emergency services, emergency contacts (e.g. the owner, veterinarian, milk handler, equipment dealers and/or power company, etc.), and the site address posted in a prominent place on the facility in the language(s) which the family and non family employees with animal care responsibilities understand?'}
                value={data.questions.q12.answer}
              />
              { data.questions.q12.notes ? <NotesRow userNotes={data.questions.q12.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'13. Facility Observations'}
                question={'Do all age classes of animals have access to clean water appropriate for climatic conditions?'}
                value={data.questions.q13.answer}
              />
              { data.questions.q13.notes ? <NotesRow userNotes={data.questions.q13.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'14. Facility Observations'}
                question={'Do all age classes of animals have access to sufficient quantities of feed for maintenance, health and growth?'}
                value={data.questions.q14.answer}
              />
              { data.questions.q14.notes ? <NotesRow userNotes={data.questions.q14.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'15. Facility Observations'}
                question={'Do all age classes of animals have a method of daily exercise (Weather permitting, if outdoors)?'}
                value={data.questions.q15.answer}
              />
              { data.questions.q15.notes ? <NotesRow userNotes={data.questions.q15.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'16. Facility Observations'}
                question={'Are all age classes of animals provided protection from heat and cold for typical climatic conditions?'}
                value={data.questions.q16.answer}
              />
              { data.questions.q16.notes ? <NotesRow userNotes={data.questions.q16.notes} /> : <BlankRow />}

            </View>

            <View>
              <QuestionAndAnswerRow
                label={'17. Facility Observations'}
                question={'Does housing allow all age classes of animals to easily stand up, lie down, adopt normal resting postures, and have visual contact with other cattle without risk of injury?'}
                value={data.questions.q17.answer}
              />
              { data.questions.q17.notes ? <NotesRow userNotes={data.questions.q17.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'18. Facility Observations'}
                question={'Do all age classes of animals have a resting area that is clean, dry, provides traction at all times when away from the milking facility and does not pose risk of injury?'}
                value={data.questions.q18.answer}
              />
              { data.questions.q18.notes ? <NotesRow userNotes={data.questions.q18.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'19. Facility Observations'}
                question={'Are facilities designed to prevent injuries, slips and falls of animals?'}
                value={data.questions.q19.answer}
              />
              { data.questions.q19.notes ? <NotesRow userNotes={data.questions.q19.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'20. Facility Observations'}
                question={'Are facilities designed to prevent unnecessary contact with electrical currents?'}
                value={data.questions.q20.answer}
              />
              { data.questions.q20.notes ? <NotesRow userNotes={data.questions.q20.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'21. Facility Observations'}
                question={'Do all animal facilities have adequate lighting for animal observation and family and non family employee with animal care responsibilities safety?'}
                value={data.questions.q21.answer}
              />
              { data.questions.q21.notes ? <NotesRow userNotes={data.questions.q21.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'22. Facility Observations'}
                question={'Does the facility provide proper ventilation throughout all housing facilities that reduces odors, dust and/or noxious gas?'}
                value={data.questions.q22.answer}
              />
              { data.questions.q22.notes ? <NotesRow userNotes={data.questions.q22.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'23. Animal & Facility Management'}
                question={'Does the written Herd Health Plan include written protocols for the treatment of common diseases including: 1. Mastitis, 2. Metritis, 3. Metabolic Diseases (Milk fever,Ketosis, DA), 4. Pneumonia, 5. Diarrhea, and any additional routinely occurring diseases identified by the veterinarian?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q23.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q23.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q23.consistency.answer
                }]}
              />
              { data.questions.q23.notes ? <NotesRow userNotes={data.questions.q23.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'24. Animal & Facility Management'}
                question={'Does the written Herd Health Plan include written vaccination protocols that specifies: 1. Age(s)/stage when vaccination given, 2. Product used, 3. Dosage administered, 4. Route of administration, and 5. Withdrawal times?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q24.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q24.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q24.consistency.answer
                }]}
              />
              { data.questions.q24.notes ? <NotesRow userNotes={data.questions.q24.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'25. Animal & Facility Management'}
                question={'Does the written Herd Health Plan include written vaccination protocols that specifies: 1. Age(s)/stage when vaccination given, 2. Product used, 3. Dosage administered, 4. Route of administration, and 5. Withdrawal times?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q25.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q25.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q25.consistency.answer
                }]}
              />
              { data.questions.q25.notes ? <NotesRow userNotes={data.questions.q25.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'26. Animal & Facility Management'}
                question={'Does the facility have a written protocol for fitness to transport that includes the definition of animals that are eligible to be marketed and outlines adherence to milk and meat withdrawal times?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q26.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q26.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q26.consistency.answer
                }]}
              />
              { data.questions.q26.notes ? <NotesRow userNotes={data.questions.q26.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'27. Animal & Facility Management'}
                question={'Does the facility have a written protocol for milking procedure?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q27.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q27.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q27.consistency.answer
                }]}
              />
              { data.questions.q27.notes ? <NotesRow userNotes={data.questions.q27.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'28. Animal & Facility Management'}
                question={'Does the written Herd Health Plan include a written protocol for pest control?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q28.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q28.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q28.consistency.answer
                }]}
              />
              { data.questions.q28.notes ? <NotesRow userNotes={data.questions.q28.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'29. Animal & Facility Management'}
                question={'Does the written Herd Health Plan include a written protocol for fly control?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q29.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q29.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q29.consistency.answer
                }]}
              />
              { data.questions.q29.notes ? <NotesRow userNotes={data.questions.q29.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'29. Animal & Facility Management'}
                question={'Does the written Herd Health Plan include a written protocol for fly control?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q29.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q29.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q29.consistency.answer
                }]}
              />
              { data.questions.q29.notes ? <NotesRow userNotes={data.questions.q29.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'31. Animal & Facility Management'}
                question={'Does the facility have a written biosecurity protocol?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q31.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q31.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q31.consistency.answer
                }]}
              />
              { data.questions.q31.notes ? <NotesRow userNotes={data.questions.q31.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'32. Animal & Facility Management'}
                question={'Does the facility have a written Emergency Action/Crisis Plan for potential emergency situations (e.g. employee injury, biosecurity, natural disasters, temperature extremes, contagious disease outbreak, power failure, manure spills, etc.)?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q32.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q32.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q32.consistency.answer
                }]}
              />
              { data.questions.q32.notes ? <NotesRow userNotes={data.questions.q32.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'33. Animal & Facility Management'}
                question={'Are all written protocols, within the Herd Health Plan, translated as needed, into the languages understood for any family and non family employees with assigned animal care responsibilities?'}
                value={data.questions.q33.answer}
              />

              <MultipleQuestion
                label={'34. Pre-Weaned Calves'}
                question={'Does the written herd health plan have a written protocol for pre-weaned calf care that includes language specific to: Protocol for difficult calvings (dystocia)?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q34.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q34.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q34.consistency.answer
                }]}
              />
              { data.questions.q34.notes ? <NotesRow userNotes={data.questions.q34.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'35. Pre-Weaned Calves'}
                question={'Does the written herd health plan have a written protocol for pre-weaned calf care that includes language specific to: Moving calves from the maternity area by lifting, walking or the use of clean, properly designed mechanical transport devices?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q35.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q35.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q35.consistency.answer
                }
              ]}
              />

              <QuestionAndAnswerLeft
                label={'Describe type of method used for movement:'}
                value={data.questions.q35.moveMethod}
              />
              { ( data.questions.q35.notes || data.herd.profile.preweanedCalfAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q35.notes} autoNotes={data.herd.profile.preweanedCalfAutoAnswerNotes} /> : <BlankRow />}

              <MultipleQuestion
                label={'36. Pre-Weaned Calves'}
                question={'Does the written herd health plan have a written protocol for pre-weaned calf care that includes language specific to: All pre-weaned calves (heifers and bulls) receiving volume and quality of colostrum or colostrum replacer within 6 hours after birth, even if immediately transported off of the farm?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q36.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q36.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q36.consistency.answer
                }]}
              />

              <QuestionAndAnswerLeft
                  label= {'Average colostrum time after birth (in hours):'}
                  value= {data.questions.q36.colostrumHours}
              />
              { ( data.questions.q36.notes || data.herd.profile.preweanedCalfAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q36.notes} autoNotes={data.herd.profile.preweanedCalfAutoAnswerNotes} /> : <BlankRow />}

              <MultipleQuestion
                label={'37. Pre-Weaned Calves'}
                question={'Does the written herd health plan have a written protocol for pre-weaned calf care that includes language specific to: All pre-weaned calves (heifers and bulls) having access to clean, fresh water appropriate for climatic conditions by day 3?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q37.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q37.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q37.consistency.answer
                }]}
              />
              { ( data.questions.q37.notes || data.herd.profile.preweanedCalfAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q37.notes} autoNotes={data.herd.profile.preweanedCalfAutoAnswerNotes} /> : <BlankRow />}

              <MultipleQuestion
                label={'38. Pre-Weaned Calves'}
                question={'Does the written herd health plan have a written protocol for pre-weaned calf care that includes language specific to: All pre-weaned calves (heifers and bulls) receiving a volume and quality of milk or milk replacer to maintain health, growth and vigor until weaned or marketed?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q38.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q38.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q38.consistency.answer
                }
              ]}
              />

              <QuestionAndAnswerLeft
                  label= {'Minimum volume of milk or milk replacer (in Quarts):'}
                  value= {data.questions.q38.minMilkVolume}
              />
              <QuestionAndAnswerLeft
                  label= {'Maximum volume of milk or milk replacer (in Quarts):'}
                  value= {data.questions.q38.maxMilkVolume}
              />
              <QuestionAndAnswerLeft
                  label= {'Number of times per day calves are fed:'}
                  value= {data.questions.q38.feedTimes}
              />
                { ( data.questions.q38.notes || data.herd.profile.preweanedCalfAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q38.notes} autoNotes={data.herd.profile.preweanedCalfAutoAnswerNotes} /> : <BlankRow />}

              <MultipleQuestion
                label={'39. Pre-Weaned Calves'}
                question={'Does the written herd health plan have a written protocol for pre-weaned calf care that includes language specific to: All calves (heifers and bulls) being offered fresh, palatable starter feed to maintain health, growth and vigor?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q39.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q39.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q39.consistency.answer
                }
              ]}
              />

              <QuestionAndAnswerLeft
                  label= {'Minimum volume of starter feed (in lbs.):'}
                  value= {data.questions.q39.minFeedVolume}
              />
              <QuestionAndAnswerLeft
                  label= {'Maximum volume of starter feed (in lbs.):'}
                  value= {data.questions.q39.maxFeedVolume}
              />
              <QuestionAndAnswerLeft
                  label= {'Number of times per day calves are fed:'}
                  value= {data.questions.q39.feedTimes}
              />

              { ( data.questions.q39.notes || data.herd.profile.preweanedCalfAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q39.notes} autoNotes={data.herd.profile.preweanedCalfAutoAnswerNotes} /> : <BlankRow />}

              <MultipleQuestion
                label={'40. Pre-Weaned Calves'}
                question={'Does the written herd health plan have a written protocol for pre-weaned calf care that includes language specific to: Calves being disbudded before 8 weeks of age?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q40.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q40.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q40.consistency.answer
                }]}
              />

              <QuestionAndAnswerLeft
                  label= {'Age of calves when disbudded (weeks):'}
                  value= {data.questions.q40.disbudWeeks}
              />
              
              { ( data.questions.q40.notes || data.herd.profile.preweanedCalfAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q40.notes} autoNotes={data.herd.profile.preweanedCalfAutoAnswerNotes} /> : <BlankRow />}

              <MultipleQuestion
                label={'41. Pre-Weaned Calves'}
                question={'Does the written herd health plan have a written protocol for pre-weaned calf care that includes language specific to: Pain mitigation provided for disbudding?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q41.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q41.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q41.consistency.answer
                }]}
              />

              <QuestionAndAnswerLeft
                  label= {'Type of pain mitigation used:'}
                  value= {data.questions.q41.painMitigationType}
              />
              { ( data.questions.q41.notes || data.herd.profile.preweanedCalfAutoAnswerNotes ) ? <NotesRow userNotes={data.questions.q41.notes} autoNotes={data.herd.profile.preweanedCalfAutoAnswerNotes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'42. Pre-Weaned Calves'}
                question={'Is the calving area clean, soft, dry, well-lit and well-ventilated?'}
                value={data.questions.q42.answer}
              />
              { data.questions.q42.notes ? <NotesRow userNotes={data.questions.q42.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'43. Non-Ambulatory Cows'}
                question={'Does the written herd health plan have a written protocol for non-ambulatory animal care that includes language specific to: Proper movement of non-ambulatory animals, including the use of special equipment?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q43.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q43.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q43.consistency.answer
                },
              ]}
              />
              <QuestionAndAnswer
                label={'Type of animal moving equipment:'}
                value={data.questions.q43.moveEquipmentType}
              />
              { data.questions.q43.notes ? <NotesRow userNotes={data.questions.q43.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'44. Non-Ambulatory Cows'}
                question={'Does the written herd health plan have a written protocol for non-ambulatory animal care that includes language specific to: Husbandry for non-ambulatory animals that provides prompt medical care?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q44.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q44.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q44.consistency.answer
                }]}
              />
              { data.questions.q44.notes ? <NotesRow userNotes={data.questions.q44.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'45. Non-Ambulatory Cows'}
                question={'Does the written herd health plan have a written protocol for non-ambulatory animal care that includes language specific to: Husbandry for non-ambulatory animals that provides feed, water, protection from heat and cold for typical climatic conditions, isolation from other ambulatory animals, and protection from predators?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q45.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q45.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q45.consistency.answer
                }]}
              />
              { data.questions.q45.notes ? <NotesRow userNotes={data.questions.q45.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'46. Non-Ambulatory Cows'}
                question={'Is there a location provided to segregate weak, sick or injured animals?'}
                value={data.questions.q46.answer}
              />
              { data.questions.q46.notes ? <NotesRow userNotes={data.questions.q46.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'47. Non-Ambulatory Cows'}
                question={'Criteria used to identify animals that are to be euthanized and outlines the immediate action of euthanasia when the criteria are met?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q47.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q47.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q47.consistency.answer
                }]}
              />
              { data.questions.q47.notes ? <NotesRow userNotes={data.questions.q47.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'48. Non-Ambulatory Cows'}
                question={'Euthanasia method that aligns with the approved methods of AABP and/or AVMA?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q48.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q48.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q48.consistency.answer
                }]}
              />
              { data.questions.q48.notes ? <NotesRow userNotes={data.questions.q48.notes} /> : <BlankRow />}

              <MultipleQuestion
                label={'49. Non-Ambulatory Cows'}
                question={'Carcasses are disposed of using an appropriate method?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q49.protocol.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q49.action.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q49.consistency.answer
                }]}
              />
              { data.questions.q49.notes ? <NotesRow userNotes={data.questions.q49.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'50. Animal Management'}
                question={'Does the facility comply with the ban on routine tail docking?'}
                value={data.questions.q50.answer}
              />
              { data.questions.q50.notes ? <NotesRow userNotes={data.questions.q50.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'51. Animal Management'}
                question={'Is each animal permanently identified with a tamper resistant individual animal ID?'}
                value={data.questions.q51.answer}
              />
              <QuestionAndAnswerLeft
                  label= {'Identification type(s) used:'}
                  value= {data.questions.q51.idTypes}
              />

              { data.questions.q51.notes ? <NotesRow userNotes={data.questions.q51.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'52. Animal Management'}
                question={'Are bulls castrated on the facility?'}
                value={data.questions.q52.answer}
              />

              <QuestionAndAnswerLeft
                label={'Age at which castration occurs (in weeks):'}
                value={data.questions.q52?.castrationWeeks}
              />
              <QuestionAndAnswerLeft
                label={'Is pain mitigation provided for castration'}
                value={data.questions.q52.q52a?.answer}
              />
              <QuestionAndAnswerLeft
                label={'Type(s) of pain mitigation used:'}
                value={data.questions.q52.q52a?.painMitigationType}
              />

              <MultipleQuestion
                label={'Does the written Herd Health Plan include a written protocol for castration?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q52.q52b?.protocol?.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q52.q52b?.action?.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q52.q52b?.consistency?.answer
                }]}
              />

              { data.questions.q52.notes ? <NotesRow userNotes={data.questions.q52.notes} /> : <BlankRow />}

              <QuestionAndAnswerRow
                label={'53. Animal Management'}
                question={'Are dairy cattle on the facility branded?'}
                value={data.questions.q53.answer}
              />
              <QuestionAndAnswerLeft
                label={'Age at which branding occurs (in weeks):'}
                value={data.questions.q53?.brandingWeeks}
              />
              <QuestionAndAnswerLeft
                label={'Is pain mitigation provided for branding?'}
                value={data.questions.q53.q53a?.answer}
              />
              <QuestionAndAnswerLeft
                label={'Type(s) of pain mitigation used:'}
                value={data.questions.q53.q53a?.painMitigationType}
              />

              <MultipleQuestion
                label={'Does the written Herd Health Plan include a written protocol for branding?'}
                answers={[{
                  label: 'Protocol meets FARM AC V4 Standards',
                  value: data.questions.q53.q53b?.protocol?.answer
                },
                {
                  label: 'Action meets FARM AC V4 Standards',
                  value: data.questions.q53.q53b?.action?.answer
                },
                {
                  label: 'Documentation Matches Actions',
                  value: data.questions.q53.q53b?.consistency?.answer
                }]}
              />

              { data.questions.q53.notes ? <NotesRow userNotes={data.questions.q53.notes} /> : <BlankRow />}
            </View>
        </Page>

        <Page size="A4" style={styles.page}>
            <View>
              <Text style={styles.h2}>Outcomes-Based Animal Observations</Text>

              <QuestionAndAnswerRow
                label={'54. Pre-Weaned Calves'}
                question={'Do 99% or more of pre-weaned calves (>2 days old) have a body condition score of 2 or greater on the FARM Body Condition Scorecard?'}
                value={data.questions.q54.answer}
              />
              { ( data.questions.q54.notes || data.questions.q54.remark ) ? <NotesRow userNotes={data.questions.q54.notes} autoNotes={data.questions.q54.remark} /> : <BlankRow />}
              <QuestionAndAnswerRow
                label={'55. Pre-Weaned Calves'}
                question={'Do 90% percent or more of pre-weaned calves (>2 days old) observed score 2 or less on the FARM Hygiene Scorecard?'}
                value={data.questions.q55.answer}
              />
              { ( data.questions.q55.notes || data.questions.q55.remark ) ? <NotesRow userNotes={data.questions.q55.notes} autoNotes={data.questions.q55.remark} /> : <BlankRow />}
              <QuestionAndAnswerRow
                label={'56. Post-Weaned Heifers'}
                question={'Do 99% or more of post-weaned heifers observed have a body condition score of 2 or greater on the FARM Body Condition Scorecard?'}
                value={data.questions.q56.answer}
              />
              { ( data.questions.q56.notes || data.questions.q56.remark ) ? <NotesRow userNotes={data.questions.q56.notes} autoNotes={data.questions.q56.remark} /> : <BlankRow />}
              <QuestionAndAnswerRow
                label={'57. Post-Weaned Heifers'}
                question={'Do 90% percent or more of post-weaned heifers, observed score 2 or less on the FARM Hygiene Scorecard?'}
                value={data.questions.q57.answer}
              />
              { ( data.questions.q57.notes || data.questions.q57.remark ) ? <NotesRow userNotes={data.questions.q57.notes} autoNotes={data.questions.q57.remark} /> : <BlankRow />}
              <QuestionAndAnswerRow
                label={'58. Pre-Fresh Heifers / Dry Cows'}
                question={'Do 90% percent or more of pre-fresh heifers/dry cows observed score 2 or less on the FARM Hygiene Scorecard?'}
                value={data.questions.q58.answer}
              />
              { ( data.questions.q58.notes || data.questions.q58.remark ) ? <NotesRow userNotes={data.questions.q58.notes} autoNotes={data.questions.q58.remark} /> : <BlankRow />}
              <QuestionAndAnswerRow
                label={'59. Lactating Cows'}
                question={'Do 99% or more of lactating cows observed have a body condition score of 2 or greater on FARM Body Condition Scorecard?'}
                value={data.questions.q59.answer}
              />
              { ( data.questions.q59.notes || data.questions.q59.remark ) ? <NotesRow userNotes={data.questions.q59.notes} autoNotes={data.questions.q59.remark} /> : <BlankRow />}
              <QuestionAndAnswerRow
                label={'60. Lactating Cows'}
                question={'Do 95% or more of lactating cows observed do not have broken tails?'}
                value={data.questions.q60.answer}
              />
              { ( data.questions.q60.notes || data.questions.q60.remark ) ? <NotesRow userNotes={data.questions.q60.notes} autoNotes={data.questions.q60.remark} /> : <BlankRow />}
              <QuestionAndAnswerRow
                label={'61. Lactating Cows'}
                question={'Do 90% percent or more of lactating cows observed score 2 or less on the FARM Hygiene Scorecard?'}
                value={data.questions.q61.answer}
              />
              { ( data.questions.q61.notes || data.questions.q61.remark ) ? <NotesRow userNotes={data.questions.q61.notes} autoNotes={data.questions.q61.remark} /> : <BlankRow />}
              <QuestionAndAnswerRow
                label={'62. Lactating Cows'}
                question={'Do 95% or more of the lactating cows observed score 2 or less on the FARM Hock Scorecard?'}
                value={data.questions.q62.answer}
              />
              { ( data.questions.q62.notes || data.questions.q62.remark ) ? <NotesRow userNotes={data.questions.q62.notes} autoNotes={data.questions.q62.remark} /> : <BlankRow />}
              <QuestionAndAnswerRow
                label={'63. Lactating Cows'}
                question={'Do 95% or more of the lactating cows observed score 2 or less on the FARM Knee Scorecard?'}
                value={data.questions.q63.answer}
              />
              { ( data.questions.q63.notes || data.questions.q63.remark ) ? <NotesRow userNotes={data.questions.q63.notes} autoNotes={data.questions.q63.remark} /> : <BlankRow />}
              <QuestionAndAnswerRow
                label={'64. Lactating Cows'}
                question={'Do 95% or more of the lactating cows observed score 2 or less on the FARM Locomotion Scorecard?'}
                value={data.questions.q64.answer}
              />
              { ( data.questions.q64.notes || data.questions.q64.remark ) ? <NotesRow userNotes={data.questions.q64.notes} autoNotes={data.questions.q64.remark} /> : <BlankRow />}

            </View>

        </Page>
      
      </Document>
    ) : (<Document
          title="National Dairy FARM Evaluation"
          author="NMPF"
          subject="NMPF Evaluation"
        >
        </Document>)
  )
}
